export default __webpack_public_path__ + "static/media/img-0650-lithuania-full-face.77653a4e.png";